angular.module('env.data.models.orderModelLite', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("OrderModelLite",
            {
                extend: ['BaseModel'],
                url: "orders",
                fields: {
                    centreId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    customerId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    deliveryAddressId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    completed: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    reference: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    summary: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    createdBy: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    expectedBy: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    requiredBy: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    value: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    archiveJobLogEntryId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    jsonData: {
                        type: RepresentationModelFieldTypes.DYNAMIC,
                        decode: function (value) {
                            return value ? JSON.parse(value) : null;
                        },
                        encode: function (value) {
                            return value ? JSON.stringify(value) : null;
                        }
                    }
                }
            }
        );
    })

;
